
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export default function Cookies() {
  return (
    <div className="container mx-auto py-8 px-4 max-w-4xl">
      <div className="space-y-8">
        <div className="space-y-4">
          <Link to="/">
            <Button variant="ghost" size="sm">← Back to Home</Button>
          </Link>
          <h1 className="text-4xl font-bold text-white">Cookie Policy</h1>
          <p className="text-muted-foreground">Last updated: {new Date().toLocaleDateString()}</p>
        </div>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold">1. What Are Cookies</h2>
          <p>Cookies are small pieces of text sent by your web browser by a website you visit. A cookie file is stored in your web browser and allows the Service or a third-party to recognize you and make your next visit easier and more useful to you.</p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold">2. How We Use Cookies</h2>
          <p>We use cookies for the following purposes:</p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>Authentication - We use cookies to identify you when you visit our website and as you navigate our website</li>
            <li>Security - We use cookies as an element of the security measures used to protect user accounts</li>
            <li>Analysis - We use cookies to help us analyze the use and performance of our website and services</li>
            <li>User preferences - We use cookies to store your preferences and customize your experience</li>
          </ul>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold">3. Types of Cookies We Use</h2>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>Essential cookies - These are cookies that are required for the operation of our website</li>
            <li>Analytical cookies - These cookies allow us to recognize and count the number of visitors and to see how visitors move around our website when they are using it</li>
            <li>Functionality cookies - These are used to recognize you when you return to our website</li>
          </ul>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold">4. Your Choices Regarding Cookies</h2>
          <p>If you'd like to delete cookies or instruct your web browser to delete or refuse cookies, please visit the help pages of your web browser. Please note, however, that if you delete cookies or refuse to accept them, you might not be able to use all of the features we offer.</p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold">5. Contact Us</h2>
          <p>If you have any questions about our Cookie Policy, please contact us at:</p>
          <p className="ml-4">Email: info@preptcine.com</p>
        </section>
      </div>
    </div>
  );
}
